function Galerie() {
    return (
        <div className="Galerie">
            <div className="horizontalDiv row">
                <p className="pagecontent">GALERIE</p>
            </div>

            <div className="container">
                Wir arbeiten hier noch... <br></br>
                ...stay tuned!

            </div>
        </div>
    );
}

export default Galerie;